import type { countyOptionsType } from "./types";


export const countyOptions: countyOptionsType = {
    HU: [
        { "label": "Baranya Megye", "value": "HU-BA" },
        { "label": "Borsod-Abaúj-Zemplén Megye", "value": "HU-BZ" },
        { "label": "Bács-Kiskun Megye", "value": "HU-BK" },
        { "label": "Békés Megye", "value": "HU-BE" },
        { "label": "Csongrád Megye", "value": "HU-CS" },
        { "label": "Fejér Megye", "value": "HU-FE" },
        { "label": "Győr-Moson-Sopron Megye", "value": "HU-GS" },
        { "label": "Hajdú-Bihar Megye", "value": "HU-HB" },
        { "label": "Heves Megye", "value": "HU-HE" },
        { "label": "Jász-Nagykun-Szolnok Megye", "value": "HU-JN" },
        { "label": "Komárom-Esztergom Megye", "value": "HU-KE" },
        { "label": "Nógrád Megye", "value": "HU-NO" },
        { "label": "Pest Megye", "value": "HU-PE" },
        { "label": "Somogy Megye", "value": "HU-SO" },
        { "label": "Szabolcs-Szatmár-Bereg Megye", "value": "HU-SZ" },
        { "label": "Tolna Megye", "value": "HU-TO" },
        { "label": "Vas Megye", "value": "HU-VA" },
        { "label": "Veszprém Megye", "value": "HU-VE" },
        { "label": "Zala Megye", "value": "HU-ZA" }
    ],
    RO: [
        { "label": "Alba", "value": "RO-AB" },
        { "label": "Arad County", "value": "RO-AR" },
        { "label": "Argeș County", "value": "RO-AG" },
        { "label": "Bacău County", "value": "RO-BC" },
        { "label": "Bihor County", "value": "RO-BH" },
        { "label": "Bistrița-Năsăud County", "value": "RO-BN" },
        { "label": "Botoșani County", "value": "RO-BT" },
        { "label": "Brașov County", "value": "RO-BV" },
        { "label": "Brăila County", "value": "RO-BR" },
        { "label": "Bucharest", "value": "RO-B" },
        { "label": "Buzău County", "value": "RO-BZ" },
        { "label": "Caraș-Severin County", "value": "RO-CS" },
        { "label": "Cluj County", "value": "RO-CJ" },
        { "label": "Constanța County", "value": "RO-CT" },
        { "label": "Covasna County", "value": "RO-CV" },
        { "label": "Călărași County", "value": "RO-CL" },
        { "label": "Dolj County", "value": "RO-DJ" },
        { "label": "Dâmbovița County", "value": "RO-DB" },
        { "label": "Galați County", "value": "RO-GL" },
        { "label": "Giurgiu County", "value": "RO-GR" },
        { "label": "Gorj County", "value": "RO-GJ" },
        { "label": "Harghita County", "value": "RO-HR" },
        { "label": "Hunedoara County", "value": "RO-HD" },
        { "label": "Ialomița County", "value": "RO-IL" },
        { "label": "Iași County", "value": "RO-IS" },
        { "label": "Ilfov County", "value": "RO-IF" },
        { "label": "Maramureș County", "value": "RO-MM" },
        { "label": "Mehedinți County", "value": "RO-MH" },
        { "label": "Mureș County", "value": "RO-MS" },
        { "label": "Neamț County", "value": "RO-NT" },
        { "label": "Olt County", "value": "RO-OT" },
        { "label": "Prahova County", "value": "RO-PH" },
        { "label": "Satu Mare County", "value": "RO-SM" },
        { "label": "Sibiu County", "value": "RO-SB" },
        { "label": "Suceava County", "value": "RO-SV" },
        { "label": "Sălaj County", "value": "RO-SJ" },
        { "label": "Teleorman County", "value": "RO-TR" },
        { "label": "Timiș County", "value": "RO-TM" },
        { "label": "Tulcea County", "value": "RO-TL" },
        { "label": "Vaslui County", "value": "RO-VS" },
        { "label": "Vrancea County", "value": "RO-VN" },
        { "label": "Vâlcea County", "value": "RO-VL" }
    ]
}